/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_b64_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Base64 encoder and decoder. Convert text to Base64 and back, with full Unicode support and a URL-safe option. Runs in your browser.`)
};

const es_b64_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador y decodificador Base64 gratuito. Convierte texto a Base64 y viceversa, con soporte completo para Unicode y una opción segura para URL. Se ejecuta en tu navegador.`)
};

const de_b64_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Base64-Encoder und -Dekoder. Konvertiere Text zu Base64 und zurück, mit vollständiger Unicode-Unterstützung und einer URL-sicheren Option. Läuft in deinem Browser.`)
};

const nl_b64_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Base64 encoder en decoder. Zet tekst om naar Base64 en terug, met volledige Unicode-ondersteuning en een URL-veilige optie. Werkt in uw browser.`)
};

const fr_b64_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codeur et décodeur Base64 gratuits. Convertissez du texte en Base64 et vice-versa, avec support Unicode complet et une option sûre pour les URL. S'exécute dans votre navigateur.`)
};

const it_b64_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificatore e decodificatore Base64 gratuiti. Converti il testo in Base64 e ritorno, con supporto completo a Unicode e un'opzione URL-safe. Viene eseguito nel tuo browser.`)
};

const pt_br2_b64_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador e decodificador Base64 gratuito. Converta texto para Base64 e vice-versa, com suporte completo a Unicode e uma opção segura para URL. Executa no seu navegador.`)
};

const pt_b64_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador e descodificador Base64 gratuito. Converta texto para Base64 e vice-versa, com suporte completo a Unicode e uma opção segura para URL. Funciona no seu navegador.`)
};

const ja_b64_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のBase64エンコーダーとデコーダー。テキストをBase64に変換したり、その逆も可能です。完全なUnicode対応とURL-safeオプション付き。ブラウザで実行されます。`)
};

const zh_b64_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的 Base64 编码器和解码器。在文本和 Base64 之间相互转换，完整支持 Unicode，并提供 URL 安全选项。在您的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const b64_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.b64_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("b64_tool_description", locale)
	if (locale === "en") return en_b64_tool_description(inputs)
	if (locale === "es") return es_b64_tool_description(inputs)
	if (locale === "de") return de_b64_tool_description(inputs)
	if (locale === "nl") return nl_b64_tool_description(inputs)
	if (locale === "fr") return fr_b64_tool_description(inputs)
	if (locale === "it") return it_b64_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_b64_tool_description(inputs)
	if (locale === "pt") return pt_b64_tool_description(inputs)
	if (locale === "ja") return ja_b64_tool_description(inputs)
	return zh_b64_tool_description(inputs)
};